import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.22505 19.3248L5.17505 18.2748L10.95 12.4998L5.17505 6.7248L6.22505 5.6748L12 11.4498L17.775 5.6748L18.825 6.7248L13.05 12.4998L18.825 18.2748L17.775 19.3248L12 13.5498L6.22505 19.3248Z",
		fill: "#118AB2"
	})
});
export default SvgClose;
